import { Icon } from "@iconify/react";
import { useEffect, useState } from "react";
import { db } from "../../firebase/firebase";
import { collection, getDocs, doc, updateDoc } from "firebase/firestore";
import Swal from "sweetalert2";
import App from "../../App";
import { useRef } from "react";
import axios from "axios";

import { auth } from "../../firebase/firebase";
import usefbStore from "../../store/firebasestore";

function UserManagement() {
  const [users, setUsers] = useState([]);
  const uni = useRef(null)
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const certInView = useRef(null)
  const [isManagement, setmanagement] = useState(true)
  const [certImgView,setcertImgView]=useState("")
  const [clientname,setclientname]=useState(null)
  const [clientuid,setclientuid]=useState(null)
  const [clientemail,setclientemail]=useState(null)
  const setEmailList = usefbStore((s)=>s.setEmailList)
  

  function getUserLevel(accountPoints) {
    if (accountPoints >= 4000) return "Pro";
    if (accountPoints >= 2000) return "Master";
    if (accountPoints >= 1000) return "Journeyman";
    return "Rookie";
  }
const fetchUsers = async () => {
  setIsLoading(true);

  try {
    const usersRef = collection(db, "Users");
    const querySnapshot = await getDocs(usersRef);

    const usersList = [];
    const emailList = [];

    querySnapshot.forEach((docSnap) => {
      const data = docSnap.data();

      const user = {
        id: docSnap.id,
        ...data,
      };

      usersList.push(user);

     
    });

    setUsers(usersList);
    setFilteredUsers(usersList);

    // if you want to store it in state:
    setEmailList(emailList)

  } catch (error) {
    console.error("Error fetching users:", error);

    Swal.fire({
      title: "Error",
      text: "Failed to fetch users. Please try again.",
      icon: "error",
      confirmButtonColor: "#6a5acd",
    });
  } finally {
    setIsLoading(false);
  }
};
const viewCert = (url, userId, name, em) => {
  certInView.current.style.display = "flex";
  setcertImgView(url);
  setclientname(name)
  setclientuid(userId)
  setclientemail(em)
  alert(url)
};

  const rvCertView = ()=>{
        certInView.current.style.display="none"

  }
  useEffect(() => {
    if (searchTerm.trim() === "") {
      setFilteredUsers(users);
    } else {
      const filtered = users.filter(
        (user) =>
          user.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          user.em?.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredUsers(filtered);
    }
  }, [searchTerm, users]);
  useEffect(() => {
    fetchUsers();
  }, []);
  const sendDisableEmail = async (userEmail, userName) => {

    try {
      const formData = new FormData();
      formData.append("userName", userName);
      formData.append("userEmail", userEmail);
      const resp = await axios.post("https://solaraback-g1bm.onrender.com/accountTermination", formData);
      const result = await resp.json();
    } catch (error) {
      console.error("Email send error:", error);
    }
  };
  // NEW FUNCTION: Grant/Revoke Job Eligibility
  const toggleJobEligibility = async (user) => {
    const currentStatus = user.jobEligibility;
    const action = currentStatus ? "revoke" : "grant";
    const actionText = currentStatus ? "revoke" : "grant";

    const result = await Swal.fire({
      title: `${actionText === "grant" ? "Grant Access" : "Revoke Access"}`,
      text: `Are you sure you want to ${actionText} job access to ${user.name || user.em}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: `Yes, ${actionText === "grant" ? "Grant" : "Revoke"}`,
      cancelButtonText: "Cancel",
      confirmButtonColor: actionText === "grant" ? "#28a745" : "#d33",
      cancelButtonColor: "#6a5acd",
    });

    if (result.isConfirmed) {
      Swal.fire({
        title: "Processing",
        text: `Updating job eligibility...`,
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        const userRef = doc(db, "Users", user.id);
        const newEligibilityStatus = !currentStatus;
        
        await updateDoc(userRef, {
          jobEligibility: newEligibilityStatus,
          jobEligibilityUpdatedAt: new Date().toISOString(),
          ...(newEligibilityStatus && { jobEligibilityGrantedAt: new Date().toISOString() }),
        });

        // Update local state
        const updatedUsers = users.map((u) =>
          u.id === user.id ? { ...u, jobEligibility: newEligibilityStatus } : u
        );
        setUsers(updatedUsers);
        setFilteredUsers(
          filteredUsers.map((u) =>
            u.id === user.id ? { ...u, jobEligibility: newEligibilityStatus } : u
          )
        );

        Swal.fire({
          title: newEligibilityStatus ? "Access Granted" : "Access Revoked",
          text: `${user.name || user.em} has been ${newEligibilityStatus ? "granted" : "revoked"} job access.`,
          icon: "success",
          confirmButtonColor: "#6a5acd",
        });
      } catch (error) {
        console.error("Job eligibility update error:", error);
        Swal.fire({
          title: "Action Failed",
          text: "Something went wrong. Please try again.",
          icon: "error",
          confirmButtonColor: "#6a5acd",
        });
      }
    }
  };

  const disableUser = async (user) => {
    const result = await Swal.fire({
      title: "Disable Account",
      text: `Are you sure you want to disable ${user.name || user.em}'s account? They will lose access to all platform features.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Disable",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6a5acd",
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      Swal.fire({
        title: "Processing",
        text: "Disabling user account...",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        const userRef = doc(db, "Users", user.id);
        await updateDoc(userRef, {
          accountActive: false,
          accountDisabledAt: new Date().toISOString(),
          jobEligibility: false,
          disabledReason: "violation_or_poor_performance",
        });

        await sendDisableEmail(user.em, user.name || "User");

        const updatedUsers = users.map((u) =>
          u.id === user.id ? { ...u, accountActive: false, jobEligibility: false } : u
        );
        setUsers(updatedUsers);
        setFilteredUsers(
          filteredUsers.map((u) =>
            u.id === user.id ? { ...u, accountActive: false, jobEligibility: false } : u
          )
        );

        Swal.fire({
          title: "Account Disabled",
          text: `${user.name || user.em}'s account has been disabled. A notification email has been sent.`,
          icon: "success",
          confirmButtonColor: "#6a5acd",
        });
      } catch (error) {
        console.error("Disable error:", error);
        Swal.fire({
          title: "Action Failed",
          text: "Something went wrong. Please try again.",
          icon: "error",
          confirmButtonColor: "#6a5acd",
        });
      }
    }
  };

  const enableUser = async (user) => {
    const result = await Swal.fire({
      title: "Enable Account",
      text: `Are you sure you want to re-enable ${user.name || user.em}'s account?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Enable",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#28a745",
      cancelButtonColor: "#6a5acd",
    });

    if (result.isConfirmed) {
      Swal.fire({
        title: "Processing",
        text: "Enabling user account...",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        const userRef = doc(db, "Users", user.id);
        await updateDoc(userRef, {
          accountActive: true,
          accountEnabledAt: new Date().toISOString(),
        });

        const updatedUsers = users.map((u) =>
          u.id === user.id ? { ...u, accountActive: true } : u
        );
        setUsers(updatedUsers);
        setFilteredUsers(
          filteredUsers.map((u) =>
            u.id === user.id ? { ...u, accountActive: true } : u
          )
        );

        Swal.fire({
          title: "Account Enabled",
          text: `${user.name || user.em}'s account has been re-enabled.`,
          icon: "success",
          confirmButtonColor: "#28a745",
        });
      } catch (error) {
        console.error("Enable error:", error);
        Swal.fire({
          title: "Action Failed",
          text: "Something went wrong. Please try again.",
          icon: "error",
          confirmButtonColor: "#6a5acd",
        });
      }
    }
  };

  const activateUser = async (user) => {
    const result = await Swal.fire({
      title: "Activate User",
      text: `Are you sure you want to activate ${user.name || user.em}'s sec approval?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Activate",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#28a745",
      cancelButtonColor: "#6a5acd",
    });

    if (result.isConfirmed) {
      Swal.fire({
        title: "Processing",
        text: "Activating user...",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        const userRef = doc(db, "Users", user.id);
        await updateDoc(userRef, {
          secApproval: true,
          secApprovalActivatedAt: new Date().toISOString(),
        });

        const updatedUsers = users.map((u) =>
          u.id === user.id ? { ...u, secApproval: true } : u
        );
        setUsers(updatedUsers);
        setFilteredUsers(
          filteredUsers.map((u) =>
            u.id === user.id ? { ...u, secApproval: true } : u
          )
        );

        Swal.fire({
          title: "User Activated",
          text: `${user.name || user.em}'s sec approval has been activated.`,
          icon: "success",
          confirmButtonColor: "#28a745",
        });
      } catch (error) {
        console.error("Activation error:", error);
        Swal.fire({
          title: "Action Failed",
          text: "Something went wrong. Please try again.",
          icon: "error",
          confirmButtonColor: "#6a5acd",
        });
      }
    }
  };
 const rejectCert= async()=>{
   const result = await Swal.fire({
      title: "Reject Cert",
      text: `Are you sure you want to reject ${clientname}'s certificate?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Reject",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#28a745",
      cancelButtonColor: "#6a5acd",
    });

    if (result.isConfirmed) {
      Swal.fire({
        title: "Processing",
        text: "Rejecting Certificate",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        const userRef = doc(db, "Users", clientuid);
        await updateDoc(userRef, {
          certApproval: "rejected",
        });

        Swal.fire({
          title: "Cert Rejected",
          text: `${clientname}'s certificate is rejected.`,
          icon: "success",
          confirmButtonColor: "#28a745",
        }).then(()=>{
const certEmail = `
Dear ${clientname},

Thank you for submitting your certificate for verification.

After careful review, we were unable to approve your certificate at this time. This may be due to one or more of the following reasons:

• The document was unclear or unreadable.
• Required information was missing.
• The certificate could not be verified.
• The uploaded document did not meet our verification requirements.

You are welcome to upload a new certificate and resubmit it for review. Please ensure that the document is clear, complete, and accurately reflects your qualifications.

If you believe this decision was made in error or require further clarification, please contact our support team for assistance.

Thank you for your understanding.

Best regards,

The Solara Jobs Team
`;
          sendCertEmail(certEmail,clientemail)
        })
      } catch (error) {
        console.error("Rejection error:", error);
        Swal.fire({
          title: "Action Failed",
          text: "Something went wrong. Please try again.",
          icon: "error",
          confirmButtonColor: "#6a5acd",
        });
      }
    }
 }
 const approveCert = async ()=>{
 const result = await Swal.fire({
      title: "Approve Cert",
      text: `Are you sure you want to approve ${clientname}'s certificate?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Approve",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#28a745",
      cancelButtonColor: "#6a5acd",
    });

    if (result.isConfirmed) {
      Swal.fire({
        title: "Processing",
        text: "Approving Certificate",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        const userRef = doc(db, "Users", clientuid);
        await updateDoc(userRef, {
          certApproval: "approved",
        });

        Swal.fire({
          title: "Cert Approved",
          text: `${clientname}'s certificate is approved.`,
          icon: "success",
          confirmButtonColor: "#28a745",
        }).then(()=>{
 const certEmail = `
Dear ${clientname},

Congratulations! Your certificate has been successfully reviewed and approved.Your account is now eligible to participate in AI tasks and apply for contract opportunities available on Solara Jobs.

We appreciate your patience during the verification process and look forward to supporting your success on the platform.

Best regards,

The Solara Jobs Team
`;
          sendCertEmail(certEmail,clientemail)
        })
      } catch (error) {
        console.error("Approval error:", error);
        Swal.fire({
          title: "Action Failed",
          text: "Something went wrong. Please try again.",
          icon: "error",
          confirmButtonColor: "#6a5acd",
        });
      }
    }
 }

const sendCertEmail = async (certEmail) => {
  // try {
  //   const formData = new FormData();
  //   formData.append("certEmail", certEmail);
  //   formData.append("clientEmail", clientemail);

  //   const resp = await axios.post(
  //     "https://solaraback-g1bm.onrender.com/certEmailSending",
  //     formData
  //   );

  //   console.log(resp.data);

  //   if (resp.data.success) {
  //     Swal.fire({
  //       icon: "success",
  //       title: "Email Sent",
  //       text: "Certificate notification email has been sent successfully.",
  //     });
  //   }
  // } catch (error) {
  //   console.error("Email send error:", error);

  //   Swal.fire({
  //     icon: "error",
  //     title: "Email Failed",
  //     text: "Could not send notification email.",
  //   });
  // }
};

const handleReverification = async (user) => {
  try {
    const userId = user.id;
    const userName = user.name;
    const userEmail = user.em;

    if (!userId || !userName || !userEmail) {
      Swal.fire(
        "Missing Data",
        "The user's ID, name, or email is missing.",
        "warning"
      );
      return;
    }

    const token = await auth.currentUser.getIdToken();

    const url = "https://solaraback-g1bm.onrender.com/reverification";

    const resp = await axios.post(
      url,
      {
        userId: userId,
        name: userName,
        emailUser: userEmail
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      }
    );

    Swal.fire(
      "Success",
      "Reverification request sent successfully.",
      "success"
    );

    console.log(resp.data);

  } catch (error) {
    console.error(error);

    const res = error.response;

    const message =
      res?.data?.msg ||
      (res?.status === 500
        ? "Server error, please try again later."
        : "Request failed.");

    Swal.fire(
      "Request Failed",
      message,
      "warning"
    );
  }
};

const handleNewsletter = (user) => {
  console.log("Newsletter:", user);
};

const handleJobsAlert = async (user) => {
try {
    const userId = user.id;
    const userName = user.name;
    const userEmail = user.em;

    if (!userId || !userName || !userEmail) {
      Swal.fire(
        "Missing Data",
        "The user's ID, name, or email is missing.",
        "warning"
      );
      return;
    }

    const token = await auth.currentUser.getIdToken();

    const url = "https://solaraback-g1bm.onrender.com/jobsalert-users";

    const resp = await axios.post(
      url,
      {
        userId: userId,
        name: userName,
        emailUser: userEmail
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      }
    );

    Swal.fire(
      "Success",
      "Job alert email sent successfully.",
      "success"
    );

    console.log(resp.data);

  } catch (error) {
    console.error(error);

    const res = error.response;

    const message =
      res?.data?.msg ||
      (res?.status === 500
        ? "Server error, please try again later."
        : "Request failed.");

    Swal.fire(
      "Alert Failed",
      message,
      "warning"
    );
  }};


  return (
    <div className="mngUserWrapCont">
      <div className="mngUserTitle">
        <div className="searchUsersWrap">
          <div className="suiContainer">
            <input
              type="text"
              placeholder="Search by name or email"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
         <div className="searchUserIcon" onClick={() => setmanagement(true)}>
  <Icon className="faIcon" icon="material-symbols:manage-accounts-outline-rounded" />
</div>

<div className="searchUserIcon" onClick={() => setmanagement(false)}>
  <Icon className="faIcon" icon="iconamoon:certificate-badge-light" />
</div>
        </div>
      </div>

      <div className="mngMainCont">
        <div className="userRow header">
          <div className="urName">Name</div>
          {isManagement && (<>
          <div className="urEmail">Approval</div>
          <div className="urPoints">Earnings</div>
          <div className="urEligibility">Job Access</div>
          </>)}
        
         
          <div className="urAction">Action</div>
        </div>

        {isLoading ? (
          <div className="loadingState">
            <p>Loading users...</p>
          </div>
        ) : filteredUsers.length === 0 ? (
          <div className="noResults">
            <p>No users found.</p>
          </div>
        ) : isManagement == true ? (

      
        
           filteredUsers.map((user) => (
            <div className="userRow" key={user.id}>
              <div className="urName">{user.name || "N/A"}</div>
              <div className="urEmail">
                <span className={`sec-badge ${user.secApproval ? "approved" : "pending"}`}>
                  {user.secApproval ? "Approved" : "Pending"}
                </span>
              </div>
              <div className="urPoints">
                <span className={`rank-badge ${getUserLevel(user.accountPoints).toLowerCase()}`}>
                  {(user.accountBalance).toLocaleString()}
                </span>
              </div>
              <div className="urEligibility">
                {user.accountActive !== false ? (
                  <button 
                    className={`eligibility-btn ${user.jobEligibility ? "granted" : "revoked"}`}
                    onClick={() => toggleJobEligibility(user)}
                  >
                    {user.jobEligibility ? "Revoke Access" : "Grant Access"}
                  </button>
                ) : (
                  <span className="disabled-badge">Account Disabled</span>
                )}
              </div>
              <div className="urAction">
                {!user.secApproval ? (
                  <button className="activate-btn" onClick={() => activateUser(user)}>
                    Activate
                  </button>
                ) : user.accountActive !== false ? (
                  <button className="disable-btn" onClick={() => disableUser(user)}>
                    Disable
                  </button>
                ) : (
                  <button className="enable-btn" onClick={() => enableUser(user)}>
                    Enable
                  </button>
                )}
              </div>
            </div>
          ))
        
        
         
        ): (
  filteredUsers.map((user) => (
    <div className="userRow" key={user.id}>
      
      <div className="urName">
        {user.name || "N/A"}
      </div>

      <div className="urAction">
        <button
          className="activate-btn"
          onClick={() => handleReverification(user)}
        >
          Reverification
        </button>

        <button
          className="activate-btn"
          onClick={() => handleNewsletter(user)}
        >
          Newsletter
        </button>

        <button
          className="activate-btn"
          onClick={() => handleJobsAlert(user)}
        >
          Jobs Alert
        </button>
      </div>

    </div>
  ))
)
        
        }
      </div>
     
     <div className="certInView" ref={certInView}>
      <div className="civTop">
        <div className="civminiTop" onClick={()=>rvCertView()}>
          <Icon className="faIcon" icon="lets-icons:back"/>
        </div>
<img src={certImgView} alt="" />
    </div>
      <div className="civBtm">
        <button className="rejBtn" onClick={()=>rejectCert()}>Reject</button>
        <button className="aprBtn" onClick={()=>approveCert()}>Approve</button>
      </div>
     </div>


    </div>
  );
}

export default UserManagement;